import React from 'react';
import styled from 'styled-components';

/**
 * Export the button text component..
 *
 * @param buttonText
 * @returns {XML}
 * @constructor
 */
const ButtonText = ({ buttonText }) => {
    const StyledText = styled.span`
        display: inline-flex;
        padding: 0 0.31em 0 0;
    `;

    return (
        <StyledText>
            {buttonText}
        </StyledText>
    );
};

export default ButtonText;



// WEBPACK FOOTER //
// ./src/components/buttons/ButtonText.js